import React, { Fragment, FC, MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { Account, ClientSuccess, generateLink, Logout } from 'Links';
import { UserAvatar } from 'components';
import { useCurrentUser } from 'hooks';
import { isClientSuccessUser } from 'helpers';

const styles = (theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: theme.custom.palette.grey2,
    },
  });

const User: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const isClientSuccess = isClientSuccessUser(currentUser);

  function handleClick(event: MouseEvent<HTMLDivElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleChat() {
    window.Intercom && window.Intercom('showNewMessage');
    handleClose();
  }

  return (
    <Fragment>
      <span className={classes.wrapper} role="button" onClick={handleClick}>
        <UserAvatar size={28} user={currentUser} />
        <KeyboardArrowDownIcon />
      </span>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <MenuItem
          component={generateLink(`/profile/${currentUser.id}`)}
          onClick={() => handleClose()}>
          {t('user:myProfile')}
        </MenuItem>
        <MenuItem component={Account} onClick={() => handleClose()}>
          {t('user:accountSettings')}
        </MenuItem>
        <MenuItem onClick={handleChat}>{t('components:chat')}</MenuItem>
        {isClientSuccess && (
          <MenuItem component={ClientSuccess} onClick={() => handleClose()}>
            {t('components:clientSuccess')}
          </MenuItem>
        )}
        <MenuItem component={Logout}>{t('common:logout')}</MenuItem>
      </Menu>
    </Fragment>
  );
};

export default withStyles(styles)(User);
